import styled from 'styled-components';

function getHighlightStyle(_ref) {
  var highlightBundles = _ref.highlightBundles,
      isGroupLoaded = _ref.isGroupLoaded,
      isKeyLoaded = _ref.isKeyLoaded;

  if (!highlightBundles) {
    return null;
  }

  if (isGroupLoaded) {
    if (isKeyLoaded) {
      return {
        outline: '2px solid red'
      };
    }

    return {
      outline: '2px dashed red'
    };
  }

  return {
    outline: '2px dotted red'
  };
}

export default styled.span.withConfig({
  displayName: "TextComponent",
  componentId: "sc-f98pqx-0"
})(["\n  white-space: ", ";\n  ", ";\n"], function (props) {
  return props.whiteSpace || 'pre-wrap';
}, getHighlightStyle);